import { computed } from 'vue';

const smallModalThreshold = 900;
export const isSmallModal = computed(
  () => window.innerWidth < smallModalThreshold
);
